module.exports = __webpack_public_path__ + "assets/img/router_push.9c100034.jpg";